// // --- MOBILE MENU COMPONENT ---
// import React, { useState, useRef } from "react";
// import { Icon } from "@iconify/react";
// import { Link, useNavigate } from "react-router-dom";

// // Note: Assuming these file paths are correct in your project structure
// import sizeChartM from "../../assets/image/NEW-MONSINI-SIZE-CHART.png";
// import sizeChartE from "../../assets/image/Enchanted-MOB-SIZE-CHART-scaled.jpg";
// import sizeChartB from "../../assets/image/Enchanted-BRIDAL-SIZE-CHART-scaled.jpg";

// const Menu = ({ setMenu, menu, data, formatTitle, generateOptions }) => {
// 	const navigate = useNavigate();
// 	const [openMobileMenu, setOpenMobileMenu] = useState(null);
// 	const [showSizeChart, setShowSizeChart] = useState("");
// 	const [zoomed, setZoomed] = useState(false);
// 	const [isZoomActive, setIsZoomActive] = useState(false);
// 	const [zoomPosition, setZoomPosition] = useState({ x: 50, y: 50 });

// 	const imageRef = useRef(null);

// 	// Add SERVER_BASE_URL constant (adjust as needed for your environment)
// 	const SERVER_BASE_URL =
// 		process.env.REACT_APP_API_URL || "http://localhost:5000";

// 	// Constants for local size chart images
// 	const SIZE_CHART_M_URL = sizeChartM;
// 	const SIZE_CHART_B_URL = sizeChartB;
// 	const SIZE_CHART_E_URL = sizeChartE;

// 	// This function constructs the full image URL
// 	function getFullImageUrl(imagePath) {
// 		if (!imagePath) return "";
// 		const cleanPath = imagePath.replace(/^uploads\//i, "uploads/");
// 		return `${SERVER_BASE_URL}/${cleanPath}`;
// 	}

// 	// Function to get the appropriate size chart image
// 	const getSizeChartImage = (category, imageUrl) => {
// 		console.log("Getting size chart for:", category);
// 		console.log("Image URL:", imageUrl);

// 		if (imageUrl) {
// 			console.log("Using API size chart:", imageUrl);
// 			if (imageUrl.startsWith("uploads/")) {
// 				return getFullImageUrl(imageUrl);
// 			}
// 			return imageUrl;
// 		}

// 		console.log("Falling back to local images for:", category);
// 		switch (category) {
// 			case "Prom":
// 				return SIZE_CHART_M_URL;
// 			case "Bridal":
// 				return SIZE_CHART_B_URL;
// 			case "Evening":
// 				return SIZE_CHART_E_URL;
// 			default:
// 				return "";
// 		}
// 	};

// 	const handleMouseMove = (e) => {
// 		if (!imageRef.current || !zoomed) return;

// 		const rect = imageRef.current.getBoundingClientRect();
// 		// Calculate position relative to the image for transform-origin
// 		const x = (e.nativeEvent.offsetX / rect.width) * 100;
// 		const y = (e.nativeEvent.offsetY / rect.height) * 100;
// 		setZoomPosition({ x, y });
// 	};

// 	const handleMouseEnter = () => {
// 		if (zoomed) {
// 			setIsZoomActive(true);
// 		}
// 	};

// 	const handleMouseLeave = () => {
// 		setIsZoomActive(false);
// 	};

// 	const toggleMobileMenu = (menu) => {
// 		setOpenMobileMenu(openMobileMenu === menu ? null : menu);
// 	};

// 	const handleMobileSizeChart = (category, imageUrl) => {
// 		console.log("Opening size chart for:", category, "Image:", imageUrl);
// 		setShowSizeChart(category);
// 	};

// 	const handleMobileNavigate = (path) => {
// 		console.log("Navigating to:", path);
// 		navigate(path);
// 		setMenu(false);
// 	};

// 	if (!menu) return null;

// 	console.log("Mobile Menu Data:", data);

// 	return (
// 		<>
// 			{/* 🧭 SIZE CHART MODAL for Mobile */}
// 			{showSizeChart && (
// 				<div className="lg:hidden fixed inset-0 h-full bg-black bg-opacity-70 flex items-center justify-center z-[1122000] p-4">
// 					<div className="absolute top-3 right-3 z-[1122001]">
// 						<button
// 							onClick={() => setShowSizeChart("")}
// 							className="text-gray-200 hover:text-pink-500 transition">
// 							<Icon icon="heroicons:x-mark-20-solid" className="w-7 h-7" />
// 						</button>
// 					</div>
// 					<div className="absolute top-3 left-3 z-[1122001]">
// 						<button
// 							onClick={() => setZoomed((prev) => !prev)}
// 							className="text-gray-200 hover:text-pink-500 transition">
// 							<Icon
// 								icon={
// 									zoomed
// 										? "mdi:magnify-minus-outline"
// 										: "mdi:magnify-plus-outline"
// 								}
// 								className="w-7 h-7"
// 							/>
// 						</button>
// 					</div>

// 					<div className="bg-transparent  w-full flex flex-col justify-center items-center gap-5 relative top-80">
// 						{/* Image Container */}
// 						<div
// 							className={`w-full h-full max-h-[100vh] overflow-hidden flex `}>
// 							{/* Zoomable Image */}
// 							<div
// 								ref={imageRef}
// 								className="relative overflow-hidden rounded-2xl bg-gray-50 max-w-full"
// 								style={{
// 									cursor: zoomed ? "zoom-in" : "default",
// 								}}
// 								onMouseMove={handleMouseMove}
// 								onMouseEnter={handleMouseEnter}
// 								onMouseLeave={handleMouseLeave}>
// 								{/* Main Image */}
// 								<img
// 									src={getSizeChartImage(
// 										showSizeChart,
// 										data?.find(([cat]) => cat === showSizeChart)?.[1]
// 											?.sizeChartImage
// 									)}
// 									alt={`${showSizeChart} Size Chart`}
// 									className={`transition-transform duration-300 w-full object-contain`}
// 									style={{
// 										transform: zoomed ? `scale(2)` : `scale(1)`,
// 										transformOrigin: `${zoomPosition.x}% ${zoomPosition.y}%`,
// 										maxWidth: "100vw", // Ensure image respects viewport width
// 									}}
// 									onError={(e) => {
// 										console.error(`Failed to load image for ${showSizeChart}`);
// 										e.target.style.display = "none";
// 									}}
// 								/>

// 								{/* Zoom Icon */}
// 								<div
// 									className={`absolute bottom-4 right-4 bg-pink-500 text-white w-[50px] flex items-center justify-center px-0 py-[14px] rounded-full text-sm transition-opacity duration-300 ${
// 										isZoomActive && zoomed ? "opacity-100" : "opacity-0"
// 									}`}>
// 									<Icon icon="iconamoon:zoom-in-light" width="20" height="20" />
// 								</div>
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 			)}

// 			{/* 🧭 SIDEBAR MENU */}
// 			<div
// 				className={`lg:hidden fixed left-0 top-0 w-[300px] h-[125vh] bg-white shadow-md z-[10000] transition-transform duration-300 ease-in-out overflow-y-auto ${
// 					menu ? "translate-x-0" : "-translate-x-[300px]"
// 				}`}>
// 				{/* Close Button */}
// 				<div className="w-full text-end p-6">
// 					<button onClick={() => setMenu(false)}>
// 						<Icon
// 							icon="akar-icons:cross"
// 							width="2rem"
// 							height="2rem"
// 							style={{ color: "black" }}
// 						/>
// 					</button>
// 				</div>

// 				{/* Debug Info - Remove in production */}

// 				{/* Menu Items */}
// 				<ul className="flex flex-col gap-6 font-lora ps-10 pb-10">
// 					<li
// 						className="font-medium hover:text-pink-600"
// 						onClick={() => setMenu(false)}>
// 						<Link to="/">Home</Link>
// 					</li>

// 					{/* Dynamic Categories */}
// 					{data && data.length > 0 ? (
// 						data.map(([category, categoryData]) => {
// 							console.log(`Rendering ${category}:`, categoryData);
// 							const options = generateOptions(category, categoryData);
// 							const isOpen = openMobileMenu === category;

// 							return (
// 								<li key={category}>
// 									<button
// 										onClick={() => toggleMobileMenu(category)}
// 										className="flex items-center gap-2 font-medium hover:text-pink-600">
// 										{formatTitle ? formatTitle(category) : category}
// 										<Icon
// 											icon={
// 												isOpen
// 													? "akar-icons:chevron-up"
// 													: "akar-icons:chevron-down"
// 											}
// 										/>
// 									</button>
// 									{isOpen && (
// 										<ul className="ml-5 mt-2 flex flex-col gap-2">
// 											{options.length === 0 ? (
// 												<li className="text-gray-500 text-sm">
// 													No collections available
// 												</li>
// 											) : (
// 												options.map((item, index) => (
// 													<li
// 														key={index}
// 														className="hover:text-pink-600 cursor-pointer"
// 														onClick={() => {
// 															console.log(
// 																`Option clicked: ${item.label} -> ${item.value}`
// 															);
// 															if (item.value === "sizeChart") {
// 																handleMobileSizeChart(
// 																	category,
// 																	categoryData.sizeChartImage
// 																);
// 															} else {
// 																handleMobileNavigate(item.value);
// 															}
// 														}}>
// 														{item.label}
// 													</li>
// 												))
// 											)}
// 										</ul>
// 									)}
// 								</li>
// 							);
// 						})
// 					) : (
// 						<li className="text-gray-500">No categories available</li>
// 					)}

// 					{/* STATIC LINKS */}
// 					<li
// 						className="font-medium hover:text-pink-600"
// 						onClick={() => setMenu(false)}>
// 						<Link to="/about">About Us</Link>
// 					</li>
// 					<li
// 						className="font-medium hover:text-pink-600"
// 						onClick={() => setMenu(false)}>
// 						<Link to="/contact">Contact</Link>
// 					</li>
// 					<li className="xl:p-2 p-1 font-lora" onClick={() => setMenu(false)}>
// 						<Link
// 							to="https://market.monsiniprom.com/"
// 							className="text-pink-600 hover:text-pink-800 transition-colors duration-200 font-bold border border-pink-600 px-4 py-1.5 rounded-md">
// 							Retailer Login
// 						</Link>
// 					</li>
// 				</ul>
// 			</div>
// 		</>
// 	);
// };

// export default Menu;

// --- MOBILE MENU COMPONENT ---
import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";

// Note: Assuming these file paths are correct in your project structure
import sizeChartM from "../../assets/image/NEW-MONSINI-SIZE-CHART.png";
import sizeChartE from "../../assets/image/Enchanted-BRIDAL-SIZE-CHART-scaled.jpg"; // Renamed to E for Evening logic below
import sizeChartB from "../../assets/image/Enchanted-MOB-SIZE-CHART-scaled.jpg"; // Renamed to B for Bridal logic below

const Menu = ({ setMenu, menu, data, formatTitle, generateOptions }) => {
	const navigate = useNavigate();
	const [openMobileMenu, setOpenMobileMenu] = useState(null);

	// REFACTORED: showSizeChart now holds an object { category, imageUrl }
	const [showSizeChart, setShowSizeChart] = useState(null);

	const [zoomed, setZoomed] = useState(false);

	// Add SERVER_BASE_URL constant (adjust as needed for your environment)
	const SERVER_BASE_URL =
		process.env.REACT_APP_API_URL || "https://admin.monsinidress.com"; // Changed default port to match NavLg

	// Constants for local size chart images
	// Note: Reversing E and B mapping based on typical usage (B for MOB/Bridal, E for Evening)
	const SIZE_CHART_M_URL = sizeChartM;
	const SIZE_CHART_E_URL = sizeChartB; // Mob is typically Evening/Bridesmaid
	const SIZE_CHART_B_URL = sizeChartE; // Bridal is typically Bridal

	// --- INLINE SVG ICONS (Required for the modal) ---
	const CloseIcon = ({ className = "w-7 h-7", color = "white" }) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill={color === "white" ? "white" : "currentColor"}
			className={className}>
			<path
				fillRule="evenodd"
				d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
				clipRule="evenodd"
			/>
		</svg>
	);

	const MagnifyPlusIcon = ({ className = "w-7 h-7", color = "white" }) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="none"
			stroke={color}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			className={className}>
			<circle cx="11" cy="11" r="8"></circle>
			<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
			<line x1="11" y1="8" x2="11" y2="14"></line>
			<line x1="8" y1="11" x2="14" y2="11"></line>
		</svg>
	);

	const MagnifyMinusIcon = ({ className = "w-7 h-7", color = "white" }) => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="none"
			stroke={color}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			className={className}>
			<circle cx="11" cy="11" r="8"></circle>
			<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
			<line x1="8" y1="11" x2="14" y2="11"></line>
		</svg>
	);
	// ---------------------------------------------

	// This function constructs the full image URL
	function getFullImageUrl(imagePath) {
		if (!imagePath) return "";
		const cleanPath = imagePath.replace(/^uploads\//i, "uploads/");
		return `${SERVER_BASE_URL}/${cleanPath}`;
	}

	// Function to get the appropriate size chart image (API or correct local fallback)
	const getSizeChartImage = (category, imageUrl) => {
		if (imageUrl) {
			if (imageUrl.startsWith("uploads/")) {
				return getFullImageUrl(imageUrl);
			}
			return imageUrl;
		}

		switch (category) {
			case "Prom":
				return SIZE_CHART_M_URL;
			case "Bridal":
				return SIZE_CHART_B_URL;
			case "Evening":
				return SIZE_CHART_E_URL;
			default:
				return SIZE_CHART_M_URL; // Default fallback to Prom
		}
	};

	// Helper function to determine the ultimate fallback URL for onError
	const getUltimateFallbackUrl = (category) => {
		switch (category) {
			case "Prom":
				return SIZE_CHART_M_URL;
			case "Bridal":
				return SIZE_CHART_B_URL;
			case "Evening":
				return SIZE_CHART_E_URL;
			default:
				return SIZE_CHART_M_URL;
		}
	};

	const toggleMobileMenu = (menu) => {
		setOpenMobileMenu(openMobileMenu === menu ? null : menu);
	};

	// UPDATED: Now sets the category and imageUrl object
	const handleMobileSizeChart = (category, imageUrl) => {
		console.log("Opening size chart for:", category, "Image:", imageUrl);
		setShowSizeChart({ category, imageUrl });
	};

	const handleMobileNavigate = (path) => {
		console.log("Navigating to:", path);
		navigate(path);
		setMenu(false);
	};

	if (!menu) return null;

	// Destructure modal content variables from state for cleaner use
	const modalCategory = showSizeChart?.category;
	const modalImageUrl = showSizeChart?.imageUrl;

	return (
		<>
			{/* 🧭 SIZE CHART MODAL for Mobile */}
			{showSizeChart && (
				<div
					className="fixed inset-0 h-screen  lg:hidden  bg-black bg-opacity-70 flex items-center justify-center z-[5000000] p-4 backdrop-blur-sm"
					onClick={() => setShowSizeChart(null)} // Close when clicking backdrop
				>
					<div
						className="relative h-full w-full rounded-lg p-0 sm:p-6 max-w-7xl flex flex-col justify-center items-center shadow-xl"
						onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
					>
						{/* ❌ Close Button */}
						<button
							onClick={() => setShowSizeChart(null)}
							className="absolute top-4 right-4 z-10 p-2 bg-white/20 rounded-full hover:bg-white/40 transition-colors duration-200"
							aria-label="Close">
							<CloseIcon />
						</button>

						{/* 🔍 Zoom Button */}
						<button
							onClick={() => setZoomed((prev) => !prev)}
							className="absolute top-4 left-4 z-10 p-2 bg-white/20 rounded-full hover:bg-white/40 transition-colors duration-200"
							aria-label="Zoom">
							{zoomed ? <MagnifyMinusIcon /> : <MagnifyPlusIcon />}
						</button>

						{/* 🖼️ Image Container */}
						<div
							className={`overflow-auto w-full h-full flex items-center justify-center p-8 transition-all duration-500 ease-in-out`}>
							<img
								src={getSizeChartImage(modalCategory, modalImageUrl)}
								alt={`${modalCategory} Size Chart`}
								className={`h-auto rounded-md object-contain transition-transform duration-500 ease-in-out ${
									zoomed ? "scale-150" : "scale-100 max-h-full max-w-full"
								}`}
								onError={(e) => {
									console.error(
										`Failed to load image for ${modalCategory}. Attempting ultimate fallback.`
									);
									// CORRECTED: Use the ultimate fallback logic
									e.target.src = getUltimateFallbackUrl(modalCategory);
								}}
							/>
						</div>
					</div>
				</div>
			)}

			{/* 🧭 SIDEBAR MENU */}
			<div
				className={`lg:hidden fixed left-0 top-0 w-[300px] h-[125vh] bg-white shadow-md z-[10000] transition-transform duration-300 ease-in-out overflow-y-auto ${
					menu ? "translate-x-0" : "-translate-x-[300px]"
				}`}>
				{/* Close Button */}
				<div className="w-full text-end p-6">
					<button onClick={() => setMenu(false)}>
						<Icon
							icon="akar-icons:cross"
							width="2rem"
							height="2rem"
							style={{ color: "black" }}
						/>
					</button>
				</div>

				{/* Menu Items */}
				<ul className="flex flex-col gap-6 font-lora ps-10 pb-10">
					<li
						className="font-medium hover:text-pink-600"
						onClick={() => setMenu(false)}>
						<Link to="/">Home</Link>
					</li>

					{/* Dynamic Categories */}
					{data && data.length > 0 ? (
						data.map(([category, categoryData]) => {
							const options = generateOptions(category, categoryData);
							const isOpen = openMobileMenu === category;

							return (
								<li key={category}>
									<button
										onClick={() => toggleMobileMenu(category)}
										className="flex items-center gap-2 font-medium hover:text-pink-600">
										{formatTitle ? formatTitle(category) : category}
										<Icon
											icon={
												isOpen
													? "akar-icons:chevron-up"
													: "akar-icons:chevron-down"
											}
										/>
									</button>
									{isOpen && (
										<ul className="ml-5 mt-2 flex flex-col gap-2">
											{options.length === 0 ? (
												<li className="text-gray-500 text-sm">
													No collections available
												</li>
											) : (
												options.map((item, index) => (
													<li
														key={index}
														className="hover:text-pink-600 cursor-pointer"
														onClick={() => {
															if (item.value === "sizeChart") {
																handleMobileSizeChart(
																	category,
																	categoryData.sizeChartImage
																);
															} else {
																handleMobileNavigate(item.value);
															}
														}}>
														{item.label}
													</li>
												))
											)}
										</ul>
									)}
								</li>
							);
						})
					) : (
						<li className="text-gray-500">No categories available</li>
					)}

					{/* STATIC LINKS */}
					<li
						className="font-medium hover:text-pink-600"
						onClick={() => setMenu(false)}>
						<Link to="/about">About Us</Link>
					</li>
					<li
						className="font-medium hover:text-pink-600"
						onClick={() => setMenu(false)}>
						<Link to="/contact">Contact</Link>
					</li>
					<li className="xl:p-2 p-1 font-lora" onClick={() => setMenu(false)}>
						<Link
							to="https://market.monsiniprom.com/"
							className="text-pink-600 hover:text-pink-800 transition-colors duration-200 font-bold border border-pink-600 px-4 py-1.5 rounded-md">
							Retailer Login
						</Link>
					</li>
				</ul>
			</div>
		</>
	);
};

export default Menu;
